import { SpaceCompleteCard } from "routes/schedule/my-schedules/my-group-types/space/spaceCompleteCard"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function SpaceDisplay() {
    const { parentItem } = useBoundContext()
    const space = parentItem.data
    return <SpaceCompleteCard space={space} />
}
